import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=254d88fc&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=ts"
export * from "./NotificationCenter.vue?vue&type=script&lang=ts"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=254d88fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d88fc",
  null
  
)

export default component.exports